export const getRequiredAuthHeaders = () => {
  return {
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};
